import { ImageFilter } from '@core/models/image-filter.model';

export class ApolloFilter implements ImageFilter{
    public page: number;
    public type: string;
    public options: any;
}
